const FLINKS_LANGUAGES = ['en', 'fr'];

// eslint-disable-next-line import/prefer-default-export
export const flinksLanguages = (language) => (
  FLINKS_LANGUAGES.includes(language) ? language : 'en'
);
